import { render, staticRenderFns } from "./ClientViewSidebar.vue?vue&type=template&id=12d6795e"
import script from "./ClientViewSidebar.vue?vue&type=script&lang=ts"
export * from "./ClientViewSidebar.vue?vue&type=script&lang=ts"
import style0 from "./ClientViewSidebar.vue?vue&type=style&index=0&id=12d6795e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports